import React from 'react';
import styled from 'styled-components';
import StatsBox from './StatsBox';
import { Flex } from './shared/Flex';
import { isMobile } from '@biosensesignal/web-sdk';

// ✅ Modern, readable wrapper
const Wrapper = styled(Flex)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: linear-gradient(90deg, #2196f3, #21cbf3); /* Dark semi-transparent */
  backdrop-filter: blur(8px); /* Optional: glass effect (remove if unsupported) */
  border-radius: 16px;
  padding: 16px 24px;
  box-sizing: border-box;
  min-width: 200px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
`;

const BoxesWrapper = styled(Flex)`
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  justify-content: center;
`;

interface VitalSign<T> {
  value: T;
  isEnabled: boolean;
}

export type BloodPressureValue = {
  systolic: number;
  diastolic: number;
};

interface IStats {
  vitalSigns: {
    pulseRate: VitalSign<number>;
    bloodPressure?: VitalSign<BloodPressureValue>;
    oxygenSaturation?: VitalSign<number>;
    // Add others as needed
  };
}

// ✅ Optional: If you want to support more vitals later
const Stats = ({ vitalSigns }: IStats) => {
  const showPulse = vitalSigns.pulseRate.isEnabled;
  const showBP = vitalSigns.bloodPressure?.isEnabled;
  const showSpO2 = vitalSigns.oxygenSaturation?.isEnabled;

  // Only show if at least one is enabled
  if (!showPulse && !showBP && !showSpO2) {
    return null;
  }

  return (
    <Wrapper>
      <BoxesWrapper>
        {showPulse && (
          <StatsBox
            title="心率"
            value={`${vitalSigns.pulseRate.value || '--'} BPM`}
          />
        )}
      </BoxesWrapper>
    </Wrapper>
  );
};

export default Stats;